import { deleteWireDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: deleteWireDepositSlice, asyncAction: deleteWireDepositAction } = createAsyncSlice(
  'deleteWireDepositSlice',
  deleteWireDepositAsync
);
